<template>
    <v-card dark outlined max-height="calc(100vh - 46px - 24px - 12px - 16px - 64px)" style="overflow: hidden" ref="room-video-card">
        <v-responsive :aspect-ratio="4 / 3" content-class="grey lighten-5" ref="container">
            <video
                :src-object.prop.camel="stream_video"
                v-bind="{
                    width,
                    height,
                }"
                autoplay
                playsinline
                class="room-video__video mb-n8"
            />
        </v-responsive>
        <v-fade-transition>
            <v-overlay v-show="enabled_video === false" absolute color="black" opacity="1">
                <v-row class="flex-column grey--text" align="center">
                    <v-col cols="auto">
                        <v-icon size="80" color="grey">mdi-camera-off</v-icon>
                    </v-col>
                    <v-col cols="auto">
                        <span>카메라가 꺼져있습니다</span>
                    </v-col>
                </v-row>
            </v-overlay>
        </v-fade-transition>

        <div class="room-video__title">
            <span> {{ title }} </span>
            <video-voice v-if="!!peer" v-bind="{ report }" />
            <template v-if="enabled_audio === false">
                <v-icon small class="ml-8">mdi-microphone-off</v-icon>
            </template>
        </div>

        <video-border v-if="!!peer" v-bind="{ report }" />
        <video-report v-if="!!peer" v-model="report" v-bind="{ peer }" />
    </v-card>
</template>

<script>
import SimplePeer from "simple-peer";

import VideoBorder from "./video/video-border.vue";
import VideoReport from "./video/video-report.vue";
import VideoVoice from "./video/video-voice.vue";
import { mapState } from "vuex";

export default {
    components: {
        VideoBorder,
        VideoReport,
        VideoVoice,
    },
    props: {
        name: { type: String, default: null },
        username: { type: String, default: null },

        peer: { type: SimplePeer, default: null },
        stream: { type: MediaStream, default: null },

        enabled_audio: { type: Boolean, default: undefined },
        enabled_video: { type: Boolean, default: undefined },
    },
    computed: {
        ...mapState("interview/client", ["enabled_muted"]),
        title() {
            let texts = [];
            if (this.name) texts.push(this.name);
            if (this.username) texts.push(this.username);
            if (texts.length < 1) texts.push("내 화면");
            return texts.join(" / ");
        },
        stream_video() {
            let stream = new MediaStream();

            let audio = this.stream?.getAudioTracks?.()?.[0];
            let video = this.stream?.getVideoTracks?.()?.[0];

            if (audio && !this.enabled_muted) stream.addTrack(audio);
            if (video) stream.addTrack(video);

            console.log("getAudioTracks", stream.getAudioTracks());
            console.log("getVideoTracks", stream.getVideoTracks());

            return stream;
        },
    },
    data: () => ({
        report: {
            audioLevel: 0,
        },

        width: 0,
        height: 0,
    }),
    methods: {
        setSize() {
            const intervalId = setInterval(() => {
                const roomVideoCard = this.$refs["room-video-card"]?.$el;
                if (roomVideoCard) {
                    const [{ width, height }] = roomVideoCard?.getClientRects?.() || [];
                    this.width = width;
                    this.height = height;
                    clearInterval(intervalId);
                }
            }, 10);
        },
    },
    mounted() {
        this.setSize();
        window.addEventListener("resize", this.setSize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setSize);
    },
};
</script>


<style lang="scss" scoped>
.room-video {
    &__title {
        position: absolute;
        top: 0;
        left: 0;

        display: flex;
        align-items: center;

        width: 100%;
        padding: 8px 12px;
        background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));

        z-index: 10;
    }

    &__video {
        object-fit: cover;
        position: absolute;
    }
}
</style>